/**
 * @file
 * Shop filters script.
 */

let $sidebar = $('.sidebar-inner', context);
let $body = $('body', context);

$sidebar.once('search-filter').each(function() {
  let $this = $(this);
  let $resetButton = $this.find('.reset-filter');

  // Floating labels on expose search form.
  $this.find('.bef-exposed-form form').each(function() {
    new FloatLabels($(this)[0], {
      prefix: 'fl-',
      prioritize: 'label',
      transform: 'input'
    });
  });

  // Show / hide filter panel for small to medium screen.
  $this.find('.sidebar-inner-title').click(function(event) {
    event.preventDefault();
    $sidebar.toggleClass('is-active');
    $body.toggleClass('is-fixed');
  });

  $this.find('.facet-item a.is-active').each(function() {
    $this = $(this);
    $resetButton.show();
    $this.closest('.accordion-item').addClass('is-active');
    $this.closest('.accordion-content').show();
  });

  // Recalculate columns height when accordion items expand or collapse.
  $this.find('.accordion').on('down.zf.accordion up.zf.accordion', function() {
    Foundation.reInit($('.cpl-layout-shop-sidebar-left'));
  });
});

// Hide title when no results.
const $noResults = $('.view-shop-products .no-results', context);

$noResults.once('hide-title-no-results').each(function() {
  $('.view-shop-products .no-results')
    .closest('.views-element-container')
    .find('.block-title')
    .first()
    .hide();
});

// Re-initiate layout equalizers on accordion menu click
const $shopSidebar = $('.cpl-layout-shop-sidebar-left .sidebar-inner', context);

$shopSidebar.once('shop-sidebar').each(function() {
  const $this = $(this);

  $this.find('[data-accordion]').each(function() {
    $(this).on('up.zf.accordion down.zf.accordion', function() {
      Foundation.reInit($('[data-equalizer]'));
    });
  });
});
